import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-sm bg-white rounded-xl shadow-sm border border-slate-200 p-6 text-center">
        <h1 className="text-lg font-semibold text-wantok-800">Page not found</h1>
        <p className="text-sm text-slate-500 mt-2">The link may be broken or the page has moved.</p>
        <Link to="/" className="inline-block mt-4 text-sm underline text-wantok-700">Go home</Link>
      </div>
    </div>
  )
}
